import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private cache = new Map<string, { response: HttpResponse<any>, expiry: number }>();
  private readonly CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutos de caché

  // Endpoints que queremos cachear para mejorar la velocidad
  private readonly CACHEABLE_ENDPOINTS = [
    'categoriasarticulosweb',
    'marcasweb',
    'sucursalesweb',
    'configuracionecommerce',
    'categoriasweb'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Solo cacheamos peticiones GET
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    const endpoint = this.getEndpointName(req.url);
    if (!this.CACHEABLE_ENDPOINTS.includes(endpoint)) {
      return next.handle(req);
    }

    const cached = this.cache.get(req.urlWithParams);
    if (cached && Date.now() < cached.expiry) {
      console.log(`DEBUG: CacheInterceptor -> Entregando '${endpoint}' desde la caché.`);
      return of(cached.response);
    }

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          console.log(`DEBUG: CacheInterceptor -> Almacenando '${endpoint}' en caché.`);
          this.cache.set(req.urlWithParams, {
            response: event,
            expiry: Date.now() + this.CACHE_DURATION_MS
          });
        }
      })
    );
  }

  private getEndpointName(url: string): string {
    const parts = url.split('/');
    return parts[parts.length - 1].split('?')[0];
  }
}
